import { apiFetch } from './apiFetch'
import { unauthenticateAppState } from './unauthenaticateAppState'

export const hasUserAgreedToLatestAcceptancePackage = async () => {
  try {
    const data = await apiFetch({
      url: '/has-agreed-to-current-acceptance-package',
      body: null,
    })

    return data
  } catch (error) {
    // did we get a 401? That means the user is not authenticated. We generally shouldn't end up here unless the user is
    // already on the login path - but if we do, we should clear the app state and redirect to login.
    if (error && typeof error === 'object' && 'statusCode' in error && error.statusCode === 401) {
      await unauthenticateAppState()
    }
  }

  return false
}
